import MobileDetect from 'mobile-detect';

export const isMobile = userAgent => {
  const mobilDetect = new MobileDetect(userAgent);
  return !!mobilDetect.mobile();
};
